// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c80d1ffc","506":"7757fd74"}[chunkId] + ".chunk.js";
};